import React, { Fragment } from 'react';
import Header from '../layout/header/singlePageHeader';
import Footer from '../layout/footer/footer-5';
import Card from '../container/element/card/card-style-10';
import Cta from '../content/cta/cta-sm-2';


const Service = () => {
    return (
        <Fragment>

            <Header pageTitle='Hardware & Services'/>
            <section className="p-top-110 p-bottom-40">
                <Card from={0} to={3} noDetails={1}/>
                <Card from={3} to={6} noDetails={1}/>/>
                <Card from={6} to={9} noDetails={1}/>/>
            </section>
            {/*<Cta />*/}
            <Footer />
        </Fragment>
    )
}

export default Service;
